<template>
  <v-row
    justify=center>
    <v-col
      cols=auto>
      <v-sheet
        :color="baseColor"
        class=main--text
        max-width=900>
        <v-container
          fluid>
          <v-row
            no-gutters>
            <v-col
              v-show="$vuetify.breakpoint.mdAndUp"
              cols=2>
              <v-container
                fill-height>
                <v-row
                  justify=center
                  align=center>
                  <v-col
                    cols=auto>
                    <v-icon
                      large
                      dark>fas fa-chalkboard-teacher</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              cols=12
              sm=12
              md=8>
              <v-container
                fluid>
                <v-row
                  justify=center
                  no-gutters>
                  <v-col
                  cols=auto>
                    <h2 class="white--text">無料体験受付中</h2>
                  </v-col>
                </v-row>
                <v-row
                  justify=center>
                  <v-col
                    cols=auto
                    >
                    <v-btn
                      rounded
                      x-large
                      :color="buttonColor"
                      dark
                      class="main--text font-weight-bold"
                      href="#what-is-prosense-2-application-form"
                      @click="emitJumpEvent"
                      ><span :style="'color: '+buttonTextColor">▶無料お申し込みはコチラ</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row
                  justify=center
                  no-gutters>
                  <h4 class="white--text">まずはお気軽に<br>ご連絡ください</h4>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              v-show="$vuetify.breakpoint.mdAndUp"
              cols=2>
              <v-container
                fill-height>
                <v-row
                  justify=center
                  align=center>
                  <v-col
                    cols=auto>
                    <v-icon
                      large
                      dark>fas fa-child</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    buttonID: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      baseColor: "#2fb16d",
      baseTextColor: "white",
      buttonColor: "#ffd41d",
      buttonTextColor: "#256cb8"
    }
  },
  methods: {
    emitJumpEvent() {
      this.$emit('jump-button-clicked', this.buttonID)
    }
  }
}
</script>
